import { render } from "./submission-notification.vue?vue&type=template&id=4f6ce481&scoped=true&ts=true"
import script from "./submission-notification.vue?vue&type=script&lang=ts"
export * from "./submission-notification.vue?vue&type=script&lang=ts"

import "./submission-notification.vue?vue&type=style&index=0&id=4f6ce481&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6ce481"]])

export default __exports__